// Chips de forma de pago (financieras | contado) con el resumen «Aplica con …» debajo.
import { Fragment } from 'react';
import { ScopeChip, type ScopeChipTone } from '@/shared/patterns/ScopeChips';
import type { PromotionPaymentOption } from '../api/promotionsContract';
import { PAYMENT_OPTION_GROUPS, paymentOptionsSummary } from '../lib/salePromotionFormOptions';
import { toggleIn } from './ScopePickers';

const PAYMENT_TONE: ScopeChipTone = {
    chip: 'border-info-soft-border bg-info-soft text-info',
    dot: 'border-info bg-info',
};

export interface PaymentOptionsPickerProps {
    selected: PromotionPaymentOption[];
    onChange: (next: PromotionPaymentOption[]) => void;
}

export function PaymentOptionsPicker({ selected, onChange }: PaymentOptionsPickerProps) {
    return (
        <>
            <div className="flex flex-wrap items-center gap-1.5">
                {PAYMENT_OPTION_GROUPS.map((group, index) => (
                    <Fragment key={group[0]?.value}>
                        {index > 0 ? (
                            <span aria-hidden className="mx-1 h-5 w-px bg-border" />
                        ) : null}
                        {group.map((option) => (
                            <ScopeChip
                                key={option.value}
                                dim="tier"
                                tone={PAYMENT_TONE}
                                label={option.label}
                                selected={selected.includes(option.value)}
                                onToggle={() => {
                                    onChange(toggleIn(selected, option.value));
                                }}
                            />
                        ))}
                    </Fragment>
                ))}
            </div>
            <p className="mt-1.5 text-[11px] font-semibold">{paymentOptionsSummary(selected)}</p>
        </>
    );
}
